module.exports = __webpack_public_path__ + "static/media/new-york-56.5df308b6.jpg";